function formatarDataHoraEvolucao(dataReferencia) {
  if (!dataReferencia) {
    return "Data nao informada";
  }

  const dataEvolucao = new Date(dataReferencia);
  if (Number.isNaN(dataEvolucao.getTime())) {
    return "Data nao informada";
  }

  return dataEvolucao
    .toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .replace(",", "");
}

export function formatarNomeCurtoUsuario(usuario, fallback = "—") {
  const nomeUsu =
    usuario?.funcionario?.nome_usu ||
    usuario?.funcionarios?.nome_usu ||
    usuario?.username ||
    "";

  const nomeCompleto = String(nomeUsu).trim().toUpperCase();
  if (!nomeCompleto) {
    return fallback;
  }

  const partes = nomeCompleto.split(/\s+/).filter(Boolean);
  return partes.length > 1 ? `${partes[0]} ${partes[1]}` : partes[0];
}

export function formatarNomeEnfermeiro(enfermeiro, fallback = "—") {
  if (!enfermeiro) {
    return fallback;
  }

  return formatarNomeCurtoUsuario(enfermeiro.usuario, fallback);
}

export function obterDescricaoEvolucaoSessao(sessao) {
  return sessao?.descricao || sessao?.evolucao?.descricao || "";
}

function formatarNomeUsuarioEvolucao(evolucao, usuarioPadrao = "Usuario") {
  return (
    evolucao?.usuario?.funcionario?.nome_usu ||
    evolucao?.usuario?.funcionarios?.nome_usu ||
    evolucao?.usuario?.username ||
    (evolucao?.usuarioId ? `Usuario ${evolucao.usuarioId}` : usuarioPadrao)
  );
}

export function formatarMetadadosEvolucao(evolucao, options = {}) {
  const { usuarioPadrao = "Usuario" } = options;

  const dataReferencia =
    evolucao?.criado_em ||
    evolucao?.createdAt ||
    evolucao?.data ||
    evolucao?.alterado_em ||
    evolucao?.updatedAt ||
    evolucao?.criadoEm;

  return {
    usuario: formatarNomeUsuarioEvolucao(evolucao, usuarioPadrao),
    dataHora: formatarDataHoraEvolucao(dataReferencia),
  };
}
